if (!customElements.get("video-media")) {
  customElements.define(
    "video-media",
    class VideoMedia extends HTMLElement {
      constructor() {
        super();
        this.video = this.querySelector("video");
        this.started = false;

        this.lazyLoadObserve();
      }

      lazyLoadObserve() {
        if (!("IntersectionObserver" in window) || !this.video) {
          // Fallback for very old browsers
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.started) {
                this.started = true;
                this.loadVideoSources();
                entry.target.load();
                
                if (entry.target.hasAttribute('autoplay')) {
                  this.playVideo(entry.target);
                }
                
                observer.unobserve(entry.target);
              }
            });
          },
          {
            // Start loading when video is 100px away from viewport
            rootMargin: "100px",
            threshold: 0
          }
        );
        
        observer.observe(this.video);
      }

      loadVideoSources() {
        if (!this.video) return;

        // Load all source elements
        const sources = this.video.querySelectorAll("source[data-src]");
        sources.forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
      }

      playVideo(videoElement = this.video) {
        if (!videoElement) return;

        // Debug: Log which source is being used
        // const activeSources = Array.from(videoElement.querySelectorAll('source'))
        //   .filter(source => source.src);
        // console.log('Active video sources:', activeSources.map(s => ({ 
        //   format: s.src.includes('.m3u8') ? 'HLS' : 'MP4',
        //   url: s.src 
        // })));

        videoElement
          .play()
          .then(() => {
            // Remove loading class after a short delay for mobile object-fit
            setTimeout(() => {
              videoElement.classList.remove("loading");
              videoElement.classList.add("loaded");
            }, 500);
          })
          .catch((error) => {
            // Handle autoplay restrictions gracefully
            console.warn("Video autoplay blocked:", error.message);
            
            // Show play button or handle muted autoplay fallback
            if (!videoElement.muted && videoElement.hasAttribute('autoplay')) {
              videoElement.muted = true;
              videoElement.play().catch(() => {
                console.warn("Muted autoplay also blocked");
              });
            }
          });
      }
    }
  );
}
